/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../components/baseclasses/guid.ts" />
/// <reference path="../../components/models/meevo.model.custom.ts" />

module Meevo.Plugins.Services {
    "use strict";

    import SecurityEntityTypeEnum = Meevo.Model.SecurityEntityTypeEnum;

    export class ServicesContext extends Meevo.Components.BaseClasses.DataMaintenanceContextBase {
        public showForceGenderPreference: boolean = false;
        public isDepositEnabled: boolean = false;
        public depositeRate: Model.RatePercent;
        serviceNotificationTemplateSection;
        public showNoCategoriesWarning: boolean = false;
        public isOwner: boolean = false;
        protected productUsageSection: ProductUsageSection;

        get customTabId(): number {
            return 99;
        }

        get customSecurityEntity(): number {
            return SecurityEntityTypeEnum.UdfService;
        }

        get customTabSecurityKey(): string {
            return this.securityKeys.DATA_SERVICE_TAB_CUSTOMUDFTABS;
        }

        constructor(appSettings: Meevo.Components.Common.IAppSettings,
            dataService: Meevo.Components.BaseClasses.IDataService,
            modalService: Meevo.Components.Modal.IModalService,
            identityService: Meevo.Components.Common.IIdentityService,
            loggingService: Meevo.Components.Logging.ILoggingService,
            securityChecker: Meevo.Components.Common.ISecurityService,
            trackingService: Meevo.Components.Tracking.ITrackingService,
            customDataContextConfig: Meevo.Model.ICustomDataContextConfig,
            protected busyService: Meevo.Components.Busy.IBusyService,
            protected translateService: angular.translate.ITranslateService,
            protected contextParams: IContextParams
        ) {

            super(
                appSettings,
                dataService,
                modalService,
                identityService,
                loggingService,
                securityChecker,
                trackingService,
                customDataContextConfig,
                false
            );
            // If DataMaintenanceContextBase.allowSectionsInitialization is called using super() some ctor services will not be available.
            this.initializeSections();
            if (this.customDataContextConfig && this.customDataContextConfig.appAreaTabs.length > 0) {
                this.renderCustomSections();
            }
        }

        initializeContext(): void {
            this.baseEndpoint = this.appSettings.API_ENDPOINTS.service;
            this.sectionTemplatePath = "app/plugins/services/sectionViews/";
            this.entityType = 'Service';
            this.getBusinessInfo();


            this.$controllersScope.$on('hasNoCategories', (event, data) => {
                this.showNoCategoriesWarning = data;
                event.preventDefault();
                event.stopPropagation();
            });
        }

        initializeSections(): void {
            this.initializeContext();
            let mainSection;
            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.DATA_SERVICE_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                this.sections.push(new MainSection(0,
                    "SECTION_SERVICES_MAIN",
                    "main.html",
                    true,
                    false,
                    this.baseEndpoint,
                    "",
                    this.loggingService,
                    this.dataService,
                    this.identityService,
                    Meevo.Model.NounEnum.ServiceMain,
                    this.appSettings,
                    this.securityKeys.DATA_SERVICE_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ));
            }

            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.DATA_EMPLOYEE_TAB_SERVICES + Meevo.Components.Common.SecurityParts.KEY_PART_READ))
                this.sections.push(new EmployeesSection(1,
                    'SECTION_SERVICES_EMPLOYEES',
                    'employees.html',
                    false,
                    false,
                    this.baseEndpoint,
                    '',
                    this.loggingService,
                    this.dataService,
                    this.identityService,
                    Model.NounEnum.ServiceEmployees,
                    this.appSettings,
                    this.modalService,
                    this.securityChecker,
                    this.securityKeys.DATA_EMPLOYEE_TAB_SERVICES + Meevo.Components.Common.SecurityParts.KEY_PART_READ)
                );

            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.DATA_SERVICE_TAB_NOTES + Meevo.Components.Common.SecurityParts.KEY_PART_READ))
                this.sections.push(new NotesSection(2, "SECTION_SERVICES_NOTES", "notes.html", false, true, this.baseEndpoint, "notes",
                    this.loggingService, this.dataService, this.identityService, null, Meevo.Model.NounEnum.ServiceNotes, this.appSettings, this.securityKeys.DATA_SERVICE_TAB_NOTES + Meevo.Components.Common.SecurityParts.KEY_PART_READ));
            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.DATA_SERVICE_TAB_RESOURCES + Meevo.Components.Common.SecurityParts.KEY_PART_READ) && !this.identityService.inCentralOfficeMode())
                this.sections.push(new ResourcesSection(3,
                    "SECTION_SERVICES_RESOURCES",
                    "resources.html",
                    false,
                    false,
                    this.baseEndpoint,
                    "resources",
                    this.loggingService,
                    this.dataService,
                    null,
                    Meevo.Model.NounEnum.ServiceResources,
                    this.modalService,
                    this.securityKeys.DATA_SERVICE_TAB_RESOURCES + Meevo.Components.Common.SecurityParts.KEY_PART_READ));

            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.DATA_SERVICE_TAB_PRODUCTUSAGE + Meevo.Components.Common.SecurityParts.KEY_PART_READ))
                this.sections.push(this.productUsageSection = new ProductUsageSection(4,
                    "SECTION_SERVICE_PRODUCT_USAGE",
                    "productUsage.html",
                    false,
                    true,
                    this.baseEndpoint,
                    "ProductUsage",
                    this.loggingService,
                    this.dataService,
                    null,
                    Meevo.Model.NounEnum.ServiceProductUsageTab,
                    this.contextParams,
                    this.modalService,
                    this.securityKeys.DATA_SERVICE_TAB_PRODUCTUSAGE + Meevo.Components.Common.SecurityParts.KEY_PART_READ));


            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.DATA_SERVICE_TAB_NOTIFICATIONS + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                this.serviceNotificationTemplateSection = new ServiceNotificationTemplateSection(5, "SECTION_SERVICES_NOTIFICATIONS", "serviceNotificationTemplate.html", false, false,
                    this.baseEndpoint, "notifications", this.loggingService, this.dataService, null, Meevo.Model.NounEnum.ServiceNotifications, null, this.securityKeys.DATA_SERVICE_TAB_NOTIFICATIONS + Meevo.Components.Common.SecurityParts.KEY_PART_READ);
                this.serviceNotificationTemplateSection.isVisible = false;
                this.sections.push(this.serviceNotificationTemplateSection);
                if (angular.isDefined(mainSection)) {
                    mainSection.notificationsSection = this.serviceNotificationTemplateSection;
                }
            }
            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.DATA_SERVICE_TAB_SWAPSPLIT + Meevo.Components.Common.SecurityParts.KEY_PART_READ))
                this.sections.push(new SwapSplitSection(6,
                    "SECTION_SERVICES_SPLIT_MERGE",
                    "swapSplit.html",
                    false,
                    false,
                    this.baseEndpoint,
                    "splitservices",
                    this.loggingService,
                    this.dataService,
                    this.identityService,
                    Meevo.Model.NounEnum.ServiceSplitMerge,
                    this.modalService,
                    this.securityKeys.DATA_SERVICE_TAB_SWAPSPLIT + Meevo.Components.Common.SecurityParts.KEY_PART_READ, this.trackingService));
            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.DATA_SERVICE_TAB_PAYROLL + Meevo.Components.Common.SecurityParts.KEY_PART_READ))
                this.sections.push(new CompensationSection(7, "SECTION_SERVICE_COMPENSATION", "compensation.html", false, false,
                    this.baseEndpoint, "compensation", this.loggingService, this.dataService, this.identityService, Meevo.Model.NounEnum.ServiceCompensationTab, this.modalService, this.securityKeys.DATA_SERVICE_TAB_PAYROLL + Meevo.Components.Common.SecurityParts.KEY_PART_READ));


        }

        selectSection(item): void {
            super.selectSection(item);
            switch (item.sectionId) {
                case this.customTabId: // custom tabs
                    this.buildCrudSecurityKeysBase(this.customTabSecurityKey);
                    break;
                default:
                    this.buildCrudSecurityKeys(this.selectedSection.sectionSecurityKey.replace(Meevo.Components.Common.SecurityParts.KEY_PART_READ, ''));
                    break;
            }
        }

        initializeHeader(model: any): void {
            this.headerContent = model.displayName;
            this.businessTypeDetail = model.businessTypeDetail;
            if (angular.isDefined(this.serviceNotificationTemplateSection)) {
                this.serviceNotificationTemplateSection.isVisible = model.isBookable;
            }

            if (this.productUsageSection)
                this.dataService.customMethodData("api/tenant/businessInfo/settings", "GET", null)
                    .then((result: any) => {
                        this.productUsageSection.isVisible = result.data.generalSettings.productUsageTracking;
                    })
            this.isOwner = model.homeLocationId === model.locationId;
            this.hideSections();

            // Get TenantDistribution model and build url
            this.dataService.customMethodData("api/tenant/businessinfo/customerportalurl", "GET", null)
                .then((result: any) => {
                    if (result && result.data && result.data.onlineBookingUrl) {
                        this.obAppSrvcUrl = result.data.onlineBookingUrl;
                    }

                    this.obAppSrvcUrl += `&serviceId=${this.selectedSection.model.id}`;
                });
        }

        hideSections() {
            const isCoImpersonating = this.isApplicationModeCO() && this.isLocationImpersonating && this.sections[1].sectionId === 1;
            const isCoAddingMode = this.isApplicationModeCO() && this.mode === Meevo.Model.MaintenanceFormState.Adding && this.sections[1].sectionId === 1;
            if (!!this.isApplicationModeCO() && !isCoImpersonating || isCoAddingMode) {
                this.sections[1].isVisible = false
            }
        }

        /**
        * Creates a new service step with whatever shape it should have when first added by a sublist.
        */
        createNewServiceStep() {
            return this.dataService.getTemplate(this.baseEndpoint, this.itemId, "step");
        }

        /**
        * Creates a new service note with whatever shape it should have when first added by a sublist.
        */

        openServiceStepModal = (context: any, serviceStep: any) => {

            let lastServiceStep = context.sections[0].model.serviceSteps.length - 1;
            let showMessageCleanupStep = false;
            if (lastServiceStep >= 0) {
                showMessageCleanupStep = context.sections[0].model.serviceSteps[lastServiceStep].isCleanupStep;
            }
            if (showMessageCleanupStep == true && serviceStep == undefined) {
                this.modalService.alert("MESSAGE_CLEAN_UP_TIME_ALREADY_EXISTS_ON_SERVICE", Components.Modal.ModalTranslationModes.Translate);
            }

            else {
                let options: Meevo.Components.Modal.IModalOptions = {
                    templateUrl: "app/plugins/services/sectionViews/serviceStepModal.html",
                    locals: {
                        context: context,
                        serviceStep: serviceStep,
                        dataService: this.dataService
                    },
                    controller: "meevo.plugins.services.ServiceStepModalController",
                    controllerAs: "vm"
                }
                this.modalService.showCustom(options);
            }
        };
 
        switch = (index1: number, index2: number, array: any) => {
            if (array[index1] && array[index2]) {
                var temp = array[index2]
                array[index2] = array[index1];
                array[index1] = temp;
            }
            this.reorderSteps(array);
        }

        reorderSteps = (array: any) => {

            for (var i = 0; i < array.length; i++)
                array[i].stepNumber = i + 1;
        }

        lastStepAsCleanupStep = (context: any, index: any) => {
            let lastServiceStep = context.sections[0].model.serviceSteps.length - 1;
            let showMessageCleanupStep = context.sections[0].model.serviceSteps[lastServiceStep].isCleanupStep;
            if (index == 0 && lastServiceStep == 1 && showMessageCleanupStep == true) {
                this.modalService.alert("MESSAGE_DELETING_LAST_SERVICE_STEP_WHEN_SERVICE_HAVE_CLEAN_UP_TIME", Components.Modal.ModalTranslationModes.Translate);
            }
            else {
                context.selectedSection.model.serviceSteps.splice(index, 1);
            }

            this.reorderSteps(context.selectedSection.model.serviceSteps);
        }

        openServicePrerequisiteModal = (context: any, servicePrerequisite: any) => {
            let options: Meevo.Components.Modal.IModalOptions = {
                templateUrl: "app/plugins/services/sectionViews/servicePrerequisiteModal.html",
                locals: {
                    context: context,
                    servicePrerequisite: servicePrerequisite,
                    dataService: this.dataService
                },
                controller: "meevo.plugins.services.ServicePrerequisiteModalController",
                controllerAs: "vm"
            }
            this.modalService.showCustom(options);
        };

        deleteServicePrerequisite = (context: any, index: any) => { 
            context.selectedSection.model.servicePrerequisites.splice(index, 1);
        };

        clearRelatedEntities(): void {
            var clearService = (<Model.Service>this.selectedSection.model);
            clearService.category = null;
            clearService.categoryDetail = null;
            clearService.visitNoteType = null;
            clearService.visitNoteTypeDetail = null;
            for (var i = 0; i < clearService.serviceSteps.length; i++) {
                clearService.serviceSteps[i].equipmentRequired = Meevo.Model.EquipmentRequiredEnum.No;
                clearService.serviceSteps[i].equipments = [];
            }
        }

        validateResourceStep(serviceStep: any): void {
            if (serviceStep.stepType == Meevo.Model.ServiceStepTypeEnum.Resource) {

                let parentItemId = this.sections[0].getParentItemId();

                let baseEndpoint = '/api/service/' + parentItemId + '/resources';
                this.dataService.customMethodData(baseEndpoint, 'GET', null).then((response) => {
                    if (response.data.resources.length == 0) {
                        this.modalService.alert('MESSAGE_SERVICE_STEP_RESOURCE_RESOURCE_REQUIRED', Meevo.Components.Modal.ModalTranslationModes.Translate).then(() => {
                        });
                    }
                });
            }
        }

        postCopy(): void {
            super.postCopy();
            let model = this.castModel<Model.Service>();
            model.displayName = '';
            model.shortcut = '';
            model.serviceSteps.forEach(step => {
                step.id = Guid.empty.toString();
                step.serviceGlobalId = Guid.empty.toString();
            });
            model.dateCreated, model.dateUpdated = '';

            for (var i = 0; i < model.serviceSteps.length; i++) {
                if (model.serviceSteps[i].stepType == Meevo.Model.ServiceStepTypeEnum.Resource) {
                    this.validateResourceStep(model.serviceSteps[i]);
                    break;
                }
            }
        }
        postUpdate(): void {
            this.selectedSection.postUpdate();
        }

        save(): angular.IPromise<any> {
            this.selectedSection.preSave();

            let model = this.castModel<Model.Service>();
            this.busyService.stop();
            let steps = Model.Guard.isSomething(model.serviceSteps) ? model.serviceSteps.length : 0;
            if (steps == 0 && this.selectedSection.isPrimarySection) {
                this.modalService.alert("LABEL_SERVICE_STEP_REQUIRED");
                return;
            }

            const hasAccessToEmployeeSection = this.selectedSection.displayNameContentKey === 'SECTION_SERVICES_MAIN' &&
                this.securityChecker.hasSecurity(this.securityKeys.DATA_EMPLOYEE_TAB_SERVICES + Meevo.Components.Common.SecurityParts.KEY_PART_WRITE)

            if (!!hasAccessToEmployeeSection && (!!model.enableBookOnlineForEmployees || !!model.enableIntelliBookingForEmployees)) {
                this.confirmBulkUpdate().then((res) => {
                    if (!res) {
                        const bulkUpdates = { enableBookOnlineForEmployees: false, enableIntelliBookingForEmployees: false };
                        this.selectedSection.model = { ...this.selectedSection.model, ...bulkUpdates }
                    }
                    return super.save()
                })
            } else {
                return super.save()
            }

        }

        get isAddressRequired(): boolean {
            let model = this.castModel<Model.Service>();
            return model.showIsAddressRequired;
        }

        confirmBulkUpdate(): angular.IPromise<any> {
            let model = this.castModel<Model.Service>();
            let message = null;
            let modal = null;
            let auditEnum = null;
            let auditVerb = null;
            let auditDesc = null;

            if (model.enableBookOnlineForEmployees && model.enableIntelliBookingForEmployees) {
                message = 'LABEL_ENABLE_BOOKONLINE_AND_INTELLIBOOKING_WARNING';
                modal = 'LABEL_SERVICE_BULKEMPLOYEES_BOOKONLINE_INTELLIBOOKING_CONFIG_MODAL'
                auditEnum = Model.NounEnum.BulkEmployeesBookOnlineIntelliBookingConfigModal;
            }
            else if (model.enableBookOnlineForEmployees) {
                message = 'LABEL_ENABLE_BOOKONLINE_FOR_EMPLOYEES_WARNING';
                modal = 'LABEL_SERVICE_BULKEMPLOYEES_BOOKONLINE_CONFIG_MODAL'
                auditEnum = Model.NounEnum.BulkEmployeesBookOnlineConfigModal;
            }
            else if (model.enableIntelliBookingForEmployees) {
                message = 'LABEL_ENABLE_INTELLIBOOKING_FOR_EMPLOYEES_WARNING';
                modal = 'LABEL_SERVICE_BULKEMPLOYEES_INTELLIBOOKING_CONFIG_MODAL'
                auditEnum = Model.NounEnum.BulkEmployeesIntelliBookingConfigModal;

            }
            if (!!message) {
                return this.modalService.confirmHandler(message).then((res: boolean) => {
                    auditDesc = this.translateService.instant(modal);
                    if (res) {
                        auditDesc += ' YesButtonClicked'
                        auditVerb = Model.VerbEnum.AcceptedButtonClicked;

                    } else {
                        auditDesc += ' NoButtonClicked'
                        auditVerb = Model.VerbEnum.RejectedButtonClicked;
                    }
                    this.trackingService.saveTrackingInfo(new Meevo.Model.TrackingItem(auditEnum
                        , auditVerb, null, model.id
                        , auditDesc))
                    return res;
                })
            }

        }

        postSave(model: any): void {

            super.postSave(model);

            if (!this.securityChecker.hasSecurity(this.securityKeys.DATA_EMPLOYEE_TAB_SERVICES + Meevo.Components.Common.SecurityParts.KEY_PART_WRITE)) {
                console.debug('Do Not Show BulkServiceConfig Modal');
                return;
            }

            if (!this.isApplicationModeCO() && _.has(model, 'numberOfEmployeesAssigned') && model.numberOfEmployeesAssigned < 1) {
                let modal = this.translateService.instant('LABEL_SERVICE_BULKSERVICECONFIG_MODAL');
                this.modalService.confirmHandler("LABEL_SERVICE_NO_EMPLOYEES_ASSIGNED").then((res: boolean) => {
                    this.trackingService.saveTrackingInfo(new Meevo.Model.TrackingItem(Model.NounEnum.BulkServiceConfigModal
                        , Model.VerbEnum.ContinueFromServicesClicked, null, model.Id
                        , `${modal} Opened`));
                    if (res) {
                        this.trackingService.saveTrackingInfo(new Meevo.Model.TrackingItem(Model.NounEnum.BulkServiceConfigModal
                            , Model.VerbEnum.AcceptedButtonClicked, null, model.Id
                            , `${modal}  Accepted Button Clicked`));
                        this.selectSection(this.sections[1]);
                    } else {
                        this.trackingService.saveTrackingInfo(new Meevo.Model.TrackingItem(Model.NounEnum.BulkServiceConfigModal
                            , Model.VerbEnum.RejectedButtonClicked, null, model.Id
                            , `${modal}  Rejected Button Clicked`));
                    }

                })
            }
        }

        getBusinessInfo() {
            var url = "api/Tenant/BusinessInfo/Settings";
            if (this.$controllersScope["services"].asLocationId) {
                url += "?asLocationId=" + this.$controllersScope["services"].asLocationId;
            }
            this.dataService
                .customMethodData(url, "GET", null)
                .then((response) => {
                    this.showForceGenderPreference = response.data.appointmentBookSettings.useGenderPreferenceWhenBookingAppointments;

                });
        }

        fileTypesEnum = Model.FileTypes;

        private _obAppSrvcUrl: string = '';

        get obAppSrvcUrl(): string {
            return this._obAppSrvcUrl;
        }
        set obAppSrvcUrl(value: string) {
            this._obAppSrvcUrl = value;
        }    }
}